import { Parser, Retriever, IState, IMessageSender } from "../../../common";
import { DatesModel } from "..";
import { Lambda, observe, IArrayChange, IArraySplice } from "mobx";

export class DatesParser implements Parser {
    private subscription: Lambda;
    private readonly retriever: Retriever<DatesModel>;
    private readonly messageSender: IMessageSender;

    constructor(retriever: Retriever<DatesModel>,  messageSender: IMessageSender) {
        this.retriever = retriever;
        this.messageSender = messageSender;
        this.subscription = () => {};
    }

    async activate(state: IState<DatesModel>) {
        this.subscription = observe(state.Items, (x) => this.sendMessageForCurrentItem(state, x))
        await this.retriever.activate(state);
        state.selectInitial();
    }

    private sendMessageForCurrentItem(state: IState<DatesModel>, change: IArrayChange<DatesModel> | IArraySplice<DatesModel>) {
        const spliceChange = change as IArraySplice<DatesModel>;
        const newItem = state.getSelectedItem();
        const oldItem = spliceChange.removed.find(x => x.id === state.SelectedItemId);
        if (newItem && oldItem && newItem.from !== oldItem.from) {
            this.messageSender.SendMessage(newItem);
        } else if(!newItem && state.Items.length > 0) {
            state.selectInitial();
        }
    }

    deactivate() {
        this.subscription();
        this.retriever.deactivate();
    }
}